export const productExtraOptionSectionWhereRequested = {
    cartButtonRequired: "Boton de compras (Requerido)",
    orderVerifySectionRequired: "Verificación de orden (Requerido)",
    orderVerifySectionOptional: "Verificación de orden (Opcional)",
    none: "No se solicita"
};
